
import 'aos/dist/aos.css'
import { defineComponent, inject, onUnmounted, ref } from 'vue'
import { useStore } from '@/store'
import { RenderingActionTypes } from '@/store/modules/rendering/action-types'
import positionSettings from '@/settings/position-settings.json'
import RenderingRandselBag from '@/components/Rendering/RenderingRandselBag.vue'
import MobileAnimationService from '@/services/form/mobile-animation.service'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingViewButtons',
  components: {
    RenderingRandselBag
  },
  setup() {
    const minDelay = 300
    const store = useStore()
    const emitter: any = inject('emitter')
    let currentCam = ref(0)
    let isVisible = ref(false)
    let isOverlayVisible = ref(false)
    let lastClick = new Date().getTime()
    let timer: any
    let mobileAnimationService = new MobileAnimationService()

    emitter.on('onHideInstruction', onHideInstruction)
    emitter.on('hideDialogs', hideDialogs)

    function onHideInstruction() {
      show()
      timer = setTimeout(() => {
        close()
      }, 2000)
    }

    const onTouch = (mouseEvent: any) => {
      if (mouseEvent.type && mouseEvent.type.length > 0 && mouseEvent.type.toString().includes('mouse')) {
        return
      }
      if (isVisible.value) {
        close()
      } else {
        show()
        emitter.emit('showOverlay')
      }
    }

    const onMouseover = () => {
      if (mobileAnimationService.isMobile()) {
        return
      }
      if (!isVisible.value) {
        if (timer) {
          clearTimeout(timer)
        }
        show()
      }
    }

    const onMouseleave = () => {
      if (mobileAnimationService.isMobile()) {
        return
      }
      timer = setTimeout(() => {
        close()
      }, 300)
    }

    function hideDialogs() {
      isVisible.value = false
      isOverlayVisible.value = false
    }

    const onNext = (_) => {
      try {
        if (lastClick + minDelay > new Date().getTime()) {
          return
        }
        let val = currentCam.value + 1
        if (val >= positionSettings.cameraPositionsRenderer.length) {
          val = 0
        }
        onSetCameraPos(val)
        lastClick = new Date().getTime()
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    const onPrev = (_) => {
      try {
        if (lastClick + minDelay > new Date().getTime()) {
          return
        }
        let val = currentCam.value - 1
        if (val < 0) {
          val = positionSettings.cameraPositionsRenderer.length - 1
        }
        onSetCameraPos(val)
        lastClick = new Date().getTime()
      } catch (err) {
        SentrySingleton.instance.captureException(err)
        console.error(err)
      }
    }

    const onSetCameraPos = (index: number) => {
      currentCam.value = index
      store.dispatch(RenderingActionTypes.SET_CAMERA_POS, currentCam.value)
      close()
    }

    function show() {
      setTimeout(() => {
        isVisible.value = true
      }, 100)
    }

    function close() {
      isVisible.value = false
      if (isOverlayVisible.value) {
        isOverlayVisible.value = false
        emitter.emit('hideOverlay')
      }
    }

    onUnmounted(() => {
      emitter.off('hideInstruction', onHideInstruction)
      emitter.off('hideDialogs', hideDialogs)
    })

    return {
      currentCam,
      isVisible,
      isOverlayVisible,
      onTouch,
      onMouseover,
      onMouseleave,
      onNext,
      onPrev,
      onSetCameraPos
    }
  }
})
